import { render } from "./VoiceControl.vue?vue&type=template&id=5c8a3c34&scoped=true"
import script from "./VoiceControl.vue?vue&type=script&lang=js"
export * from "./VoiceControl.vue?vue&type=script&lang=js"

import "./VoiceControl.vue?vue&type=style&index=0&id=5c8a3c34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8a3c34"]])

export default __exports__